import allBlogs from './allBlogs';
import { listIncludes } from './util';

export default function tagBlogs(
  includes: string[],
  start?: number,
  count?: number
) {
  const result = allBlogs().filter((obj: any) => {
    return listIncludes(includes, obj.tags);
  });

  result.sort(function (a: any, b: any) {
    return a.publishedAt > b.publishedAt
      ? -1
      : b.publishedAt > a.publishedAt
      ? 1
      : 0;
  });

  if (count) {
    if (count > result.length) {
      count = result.length;
    }
  } else {
    count = result.length;
  }

  if (start) {
    if (start + count > result.length) {
      start = result.length - count;
    }
  } else {
    start = 0;
  }

  return result.slice(start, start + count);
}
